export default function shouldUpdateUrl (search, otherSearch) {
    return search.toString() !== otherSearch.toString(true)
}
